import React, { Component } from 'react';
import { AppBar, Button } from '../components';

export default class Navbar extends Component {
  renderNavButtons() {
    if (this.props.loggedIn) {
      return <Button onClick={() => window.location = '/courses'} label="Zur App" color="primary" labelStyle={{ color: '#ffffff' }} />;
    }
    return (
      <div>
        <Button onClick={this.props.navigateTo.bind(null, '/signup')} label="Registrieren" color="primary" labelStyle={{ color: '#ffffff' }} />
        <Button onClick={this.props.navigateTo.bind(null, '/login')} label="Einloggen" color="primary" labelStyle={{ color: '#ffffff' }} />
      </div>
    );
  }
  render() {
    return (
      <AppBar
        style={{ backgroundColor: 'transparent' }}
        showMenuIconButton={false}
        titleStyle={{ display: 'none' }}
      >
        <div className="container">
          <div className="col-xs-12 col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1">
            <div className="pull-right">
              {this.renderNavButtons()}
            </div>
          </div>
        </div>
      </AppBar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.js